module.exports = __webpack_public_path__ + "img/logo.fba307ce.png";